import React from 'react';
import { colors } from '../../design/tokens';
import { typography } from '../../design/typography';

export type StatusType = 
  | 'HEALTHY' | 'MONITOR' | 'RISK' | 'CRITICAL' 
  | 'ACTIVE' | 'EXPIRED' | 'PAST_DUE' | 'BLOCKED';

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
}

const statusConfig: Record<StatusType, { bg: string; text: string }> = {
  HEALTHY: { bg: colors.healthy.light, text: colors.healthy.dark },
  MONITOR: { bg: colors.info.light, text: colors.info.dark },
  RISK: { bg: colors.warning.light, text: colors.warning.dark },
  CRITICAL: { bg: colors.critical.light, text: colors.critical.dark },
  ACTIVE: { bg: colors.healthy.light, text: colors.healthy.dark },
  EXPIRED: { bg: colors.neutral[200], text: colors.neutral[700] },
  PAST_DUE: { bg: colors.warning.light, text: colors.warning.dark },
  BLOCKED: { bg: colors.critical.light, text: colors.critical.dark },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label }) => {
  const config = statusConfig[status] || statusConfig.EXPIRED;
  
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '2px 8px',
      borderRadius: '12px',
      fontSize: typography.caption.fontSize,
      fontWeight: '600',
      backgroundColor: config.bg,
      color: config.text,
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      whiteSpace: 'nowrap'
    }}>
      {label || status}
    </span>
  );
};
